import { FunctionComponent, SVGProps } from "react";
import {
    HomeAddressIconv4,
    OfficeAddressIconv4,
    OtherAddressIconv4,
} from "@cart-ui/components/cart-address-footer/components/icons";
import { default as HomeIcon } from "@swiggy-private/dls-web-icons/dist/web/generic/home/16";
import { default as WorkIcon } from "@swiggy-private/dls-web-icons/dist/web/generic/work/16";
import { default as LocationIcon } from "@swiggy-private/dls-web-icons/dist/web/generic/location/16";
import { default as HomeFilledIcon } from "@swiggy-private/dls-web-icons/dist/web/generic/homeFilled/16";
import { default as WorkFilledIcon } from "@swiggy-private/dls-web-icons/dist/web/generic/workFilled/16";
import { default as LocationFilledIcon } from "@swiggy-private/dls-web-icons/dist/web/generic/locationFilled/16";
import { default as HomeFilledNotificationIcon } from "@swiggy-private/dls-web-icons/dist/web/generic/homeFilledNotification/16";
import { default as WorkFilledNotificationIcon } from "@swiggy-private/dls-web-icons/dist/web/generic/workFilledNotification/16";
import { default as LocationFilledNotificationIcon } from "@swiggy-private/dls-web-icons/dist/web/generic/locationFilledNotification/16";

import { TEXTS } from "@cart-ui/constants";
import { AddressInfo, UserAddress } from "@swiggy-private/cart-types";
import { ADDRESS_CATEGORIES, SwgyHeaderKeysList } from "@swiggy-private/core-types";
import { GlobalHeaderState } from "@swiggy-private/checkout-core";

import { format, capitalizeFirstLetter, isValidNumber, isAndroidPlatform } from "@swiggy-private/core-ui";
import { isEmpty } from "@swiggy-private/js-utils";

export const getDeliveryIcon = (category?: number): FunctionComponent => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let Element: FunctionComponent<any>;

    switch (category) {
        case ADDRESS_CATEGORIES.ADDRESS_CATEGORY_HOME:
            Element = HomeAddressIconv4;
            break;
        case ADDRESS_CATEGORIES.ADDRESS_CATEGORY_WORK:
            Element = OfficeAddressIconv4;
            break;
        case ADDRESS_CATEGORIES.ADDRESS_CATEGORY_FRIENDS_AND_FAMILY:
            Element = HomeAddressIconv4;
            break;
        default:
            Element = OtherAddressIconv4;
            break;
    }
    return Element;
};

export const getAddressAnnotation = (
    address: UserAddress | AddressInfo,
    addressCategory?: number,
): string => {
    let deliveryAnnotation = "";
    switch (addressCategory) {
        case ADDRESS_CATEGORIES.ADDRESS_CATEGORY_HOME:
            deliveryAnnotation = TEXTS.HOME;
            break;
        case ADDRESS_CATEGORIES.ADDRESS_CATEGORY_WORK:
            deliveryAnnotation = TEXTS.WORK;
            break;
        case ADDRESS_CATEGORIES.ADDRESS_CATEGORY_FRIENDS_AND_FAMILY:
            deliveryAnnotation = address?.name || TEXTS.HOME;
            break;
        default:
            deliveryAnnotation = address?.annotation || TEXTS.OTHER;
            break;
    }
    return deliveryAnnotation;
};

export const getDeliveryAddressTitle = (address: UserAddress): string => {
    let deliveryAnnotation = "";
    if (hasInvalidAddressCategory(address as AddressInfo)) {
        deliveryAnnotation = getAddressAnnotation(address, address?.addressCategory);
    } else {
        deliveryAnnotation =
            address?.annotation ||
            getAddressAnnotation(address, address?.userIntentAddressCategory);
    }
    return format(TEXTS.DELIVER_TO_X, capitalizeFirstLetter(deliveryAnnotation));
};

export const formatAMPM = (seconds: number) => {
    // input is epoch, and we are usign timeZone to help in test casess
    //set the initial date to the epoch and add UTC units
    const _date = new Date(0); // The 0 there is the key, which sets the date to the epoch
    const date = new Date(_date.toLocaleString("en-US", { timeZone: "Asia/Kolkata" }));
    date.setUTCSeconds(seconds);
    let hours = date.getHours();
    const minutes = date.getMinutes();
    const ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12;
    hours = hours ? hours : 12;
    const minuteToDisplay = minutes < 10 ? "0" + minutes : minutes;
    const strTime = hours + ":" + minuteToDisplay + " " + ampm;
    return strTime;
};

export const getDeliveryIconV2 = (
    isSelected: boolean,
    showAddressNudge: boolean,
    category?: number,
): ((props: SVGProps<SVGSVGElement>) => JSX.Element) => {
    switch (category) {
        case ADDRESS_CATEGORIES.ADDRESS_CATEGORY_HOME:
            if (isSelected) {
                return showAddressNudge ? HomeFilledNotificationIcon : HomeFilledIcon;
            }
            return HomeIcon;
        case ADDRESS_CATEGORIES.ADDRESS_CATEGORY_WORK:
            if (isSelected) {
                return showAddressNudge ? WorkFilledNotificationIcon : WorkFilledIcon;
            }
            return WorkIcon;
        /*
            For new addresses, category will never be FRIENDS_AND_FAMILY.
            This case exists only to support backward compatibility for older addresses. 
        */
        case ADDRESS_CATEGORIES.ADDRESS_CATEGORY_FRIENDS_AND_FAMILY:
            if (isSelected) {
                return showAddressNudge ? HomeFilledNotificationIcon : HomeFilledIcon;
            }
            return HomeIcon;
        default:
            if (isSelected) {
                return showAddressNudge ? LocationFilledNotificationIcon : LocationFilledIcon;
            }
            return LocationIcon;
    }
};

export const hasInvalidAddressCategory = (address?: AddressInfo | UserAddress | null): boolean => {
    return (
        isEmpty(address?.userIntentAddressCategory) ||
        address?.userIntentAddressCategory === ADDRESS_CATEGORIES.ADDRESS_CATEGORY_INVALID
    );
};

export const getPositionFromBottomForAddressList = () => {
    const a16MigrationBottomOffset = Number(GlobalHeaderState.getHeader(SwgyHeaderKeysList.fullScreenBottomOffset));
    const platform = GlobalHeaderState.getHeader(SwgyHeaderKeysList.platform);
    if (isValidNumber(a16MigrationBottomOffset) && isAndroidPlatform(platform)) {
        return a16MigrationBottomOffset;
    }
};
